// extracted by mini-css-extract-plugin
module.exports = {"EasilyScabable":"EasilyScabable_EasilyScabable__aJasx"};